import dayjs from 'dayjs';
import { ISelectOption } from './common';
import { IRegion } from './country';
import { ISubTable } from './subTable';
import { ITopic } from './topic';

export interface IGetDemographicsFormData {
  country: ISelectOption[];
  topic: ISelectOption[];
  subTable: ISelectOption[];
  startYear: dayjs.Dayjs | string;
  endYear: dayjs.Dayjs | string;
  stepSize: number;
  baseYear: dayjs.Dayjs | string;
  customBreakpoints: boolean;
  breakpoints: { value: number }[];
}

export interface IDemographicsData {
  topic: ITopic[];
  yearRange: number[];
  forecastYear: number;
  isChina?: boolean;
}

export interface IDataRow {
  id: number;
  name: string;
  unit: string;
  topicId: number;
  variableId: number;
  changeable?: boolean;
  isShowEquation?: boolean;
  equation?: boolean;
  viewable?: boolean;
  tooltip?: string;
  isPercentage?: boolean;
  decimalPlaces?: number;
  data?: IData;
  status?: number;
  subscription?: IData
  phone?: string,
  type?: string
}

export interface IChartData {
  baseCaseData: IDataRow;
  revisedData: IDataRow;
  forecastYear: number;
}

export interface IData {
  [key: string | number]: number;
}

export interface IDataChange {
  topicId: number;
  variableId: number;
  reversedDataChanged: IData;
}

export interface IDatasetHistory {
  id: number;
  filename: string;
  createdAt: string;
  path: string;
}

export interface IDemographicsView {
  topic: number[];
  subTable: number[];
  startYear: number;
  endYear: number;
  baseYear: number;
  stepSize: number;
  breakpoints?: { value?: number }[];
  customBreakpoints: boolean;
}

export interface IGetDemographicsParams {
  country?: (string | number)[];
  topic?: (string | number)[];
  subTable?: (string | number)[];
  startYear?: number;
  endYear?: number;
  stepSize?: number;
  baseYear?: number;
  breakpoint?: number[];
  customBreakpoints?: boolean;
}

export interface IChangeDemographicsParams extends IGetDemographicsParams {
  changedVariable: IDataChange[];
}

export interface IChangeDemographicsFormData extends IGetDemographicsFormData {
  changedVariable: IDataChange[];
}

export interface IGetDatasetHistoriesParams {
  limit: number;
  page?: number;
  keyword?: string;
  sortedField?: string;
  isDescending?: boolean;
}

export interface IEditDataRowFormData {
  id: number;
  name: string;
  unit: string;
  tooltip?: string;
}

export interface IEditUser {
  id?: number;
  firstName: string;
  lastName: string;
  email: string;
  phone?: string;
  password?: string;
  startDate: any;
  endDate: any
}

export interface IDataControl {
  regions: IRegion[];
  topics: ITopic[];
  startYear: number;
  endYear: number;
  subTables: ISubTable[];
}

export interface ISetupForecastYearFormData {
  forecastYear: number;
}
export interface IYearRecordData {
  [key: number | string]: number | string;
}
export interface IDataset {
  id: number;
  countryId?: number;
  variableId?: number;
  data: IYearRecordData;
}
export interface DataUploadDataset{
  dataset: IDataset[];
  householdDataset?: IDataset[];
  householdExpenditureDataset?: IDataset[][];
}

export enum OptionUpload{
  OPTION_1 = 1,
  OPTION_2
}
export interface IDataFile {
  baseCase: DataUploadDataset;
  revised: DataUploadDataset;
  impact: DataUploadDataset;
  isChange?: boolean;
  option: OptionUpload;
  fileName: string;
}